// utils/applySettings.js
export const applySettingsToCSS = (settings) => {
	if (settings) {
		const style = document.createElement('style');
		style.innerHTML = `
			:root {
				--p: ${hexToHSL(settings.primaryColor)};
				--pf: ${hexToHSL(settings.primaryColor)};
				--primary-color: ${settings.primaryColor};
				--s: ${hexToHSL(settings.secondaryColor)};
				--sf: ${hexToHSL(settings.secondaryColor)};
				--secondary-color: ${settings.primaryColor};
				--a: ${hexToHSL(settings.accentColor)};
				--af: ${hexToHSL(settings.accentColor)}; 
				--accent-color: ${settings.accentColor};  
			}

			.warmup { background-color: ${settings.warmUpColor || '#defaultColor'} !important; }
			.mobility { background-color: ${settings.mobilityColor || '#defaultColor'} !important; }
			.lift { background-color: ${settings.liftColor || '#defaultColor'} !important; }
			.throw { background-color: ${settings.throwColor || '#defaultColor'} !important; }
			.command { background-color: ${settings.commandColor || '#defaultColor'} !important; }
			.sprint { background-color: ${settings.sprintColor || '#defaultColor'} !important; }
			.plyo { background-color: ${settings.plyoColor || '#defaultColor'} !important; }
			.med-ball { background-color: ${settings.medballColor || '#defaultColor'} !important; }
			.fielding { background-color: ${settings.fieldingColor || '#defaultColor'} !important; }
			.hitting { background-color: ${settings.hittingColor || '#defaultColor'} !important; }
			.practice-plan { background-color: ${settings.practicePlanColor || '#defaultColor'} !important; }
    `;
		document.head.appendChild(style);
	}
};

function hexToHSL(hex) {
	// Remove the hash at the start if it's there
	hex = hex.replace(/^#/, '');

	// Parse the hex values
	let r = parseInt(hex.substring(0, 2), 16);
	let g = parseInt(hex.substring(2, 4), 16);
	let b = parseInt(hex.substring(4, 6), 16);

	// Convert to fractions of 1
	r /= 255;
	g /= 255;
	b /= 255;

	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	let h,
		s,
		l = (max + min) / 2;

	if (max === min) {
		h = s = 0; // achromatic
	} else {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				h = (g - b) / d + (g < b ? 6 : 0);
				break;
			case g:
				h = (b - r) / d + 2;
				break;
			case b:
				h = (r - g) / d + 4;
				break;
		}
		h /= 6;
	}

	// Convert to percentages and round
	s = +(s * 100).toFixed(1);
	l = +(l * 100).toFixed(1);
	h = +(h * 360).toFixed(1);

	return `${h} ${s}% ${l}%`;
}
